import { Checkbox } from '@/components/cms/ui/checkbox';
import { Choice } from '@/components/ui/choice';
import { GroupTitle } from '@/components/ui/text';
import { TEMPLATE_FEATURES, TEMPLATE_FEATURE_GROUPS } from './templateOptions';

interface Props {
  value: string[];
  onChange: (next: string[]) => void;
}

export function TemplateFeaturePicker({ value, onChange }: Props) {
  const selected = new Set(value);

  const toggle = (key: string) => {
    const next = new Set(selected);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    // Ordered by the catalog, not by click order, so a summary or gallery card reads
    // the same way whichever order the creator ticked them in.
    onChange(TEMPLATE_FEATURES.filter((f) => next.has(f.key)).map((f) => f.key));
  };

  return (
    <div className="grid grid-cols-4 gap-x-6 gap-y-4">
      {TEMPLATE_FEATURE_GROUPS.map((group) => (
        <div key={group} className="min-w-0 space-y-1.5">
          <GroupTitle>{group}</GroupTitle>
          {TEMPLATE_FEATURES.filter((f) => f.group === group).map((feature) => (
            <FeatureTick
              key={feature.key}
              label={feature.label}
              checked={selected.has(feature.key)}
              onToggle={() => toggle(feature.key)}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

function FeatureTick({
  label,
  checked,
  onToggle,
}: {
  label: string;
  checked: boolean;
  onToggle: () => void;
}) {
  return <Choice className="items-start" control={<Checkbox checked={checked} onCheckedChange={onToggle} />} label={label} />;
}
